import { type IContract } from "@framework/types";

export const collectionsEditContractFilter = ({ title, description, contractStatus, imageUrl }: IContract) => ({
  title,
  description,
  imageUrl,
  contractStatus,
});

export const prepareCollectionsContractsInitialValues = ({
  id,
  title,
  description,
  imageUrl,
  contractStatus,
  address,
  parameters,
}: Partial<IContract>) => {
  return {
    id,
    title,
    address,
    description,
    contractStatus,
    imageUrl,
    parameters,
  };
};
